import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { makeAuthenticatedRequest } from "../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { AxiosError } from "../components/sessionexpiry";
import {
  Initiatepayoutmerchants,
  Lastpayouts,
} from "../redux/InitiatepayoutSlice";
import { FunnelPlus } from "lucide-react";

const Initiatepayout = ({ isSidebarCollapsed, isMobile }) => {
  const [showInitiatePayout, setInitiatePayout] = useState(false);
  const [formData, setFormData] = useState({
    benename: "",
    phone: "",
    email: "",
    location: "",
    acctno: "",
    acctifsc: "",
    bankname: "",
    remarks: "",
    amount: "",
    //transactionType: ""
  });

  const [errors, setErrors] = useState({
    benename: "",
    phone: "",
    email: "",
    location: "",
    acctno: "",
    acctifsc: "",
    bankname: "",
    remarks: "",
    amount: "",
    //transactionType: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    let isValid = true;

    if (!formData.benename?.trim()) {
      newErrors.benename = "Beneficiary Name is required";
      isValid = false;
    }
    if (!formData.phone?.trim()) {
      newErrors.phone = "Mobile Number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Mobile Number must be 10 digits";
      isValid = false;
    }

    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Email is invalid";
      isValid = false;
    }

    if (!formData.location?.trim()) {
      newErrors.location = "Location is required";
      isValid = false;
    }

    if (!formData.acctno.trim()) {
      newErrors.acctno = "Account Number is required";
      isValid = false;
    } else if (!/^\d+$/.test(formData.acctno)) {
      newErrors.acctno = "Account Number must contain only digits";
      isValid = false;
    }

    if (!formData.acctifsc.trim()) {
      newErrors.acctifsc = "Account IFSC is required";
      isValid = false;
    }

    if (!formData.bankname.trim()) {
      newErrors.bankname = "Bank Name is required";
      isValid = false;
    }

    if (!formData.remarks.trim()) {
      newErrors.remarks = "Remarks is required";
      isValid = false;
    }

    if (!formData.amount.trim()) {
      newErrors.amount = "Amount is required";
      isValid = false;
    } else if (isNaN(formData.amount) || parseFloat(formData.amount) <= 0) {
      newErrors.amount = "Amount must be a valid number greater than 0";
      isValid = false;
    }

    setErrors(newErrors);

    if (isValid) {
      // Proceed with form submission
      setLoading(true);
      try {
        // Your API call logic here
        // await makePayoutRequest(formData);
        setLoading(false);
        setInitiatePayout(false);
        // Show success message or redirect
      } catch (err) {
        setLoading(false);
        setError(err.message);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const [error, setError] = useState(null);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState(null);

  const [profileData, setProfileData] = useState({
    mid: "",
    payout_balance: "",
    status: "",
    webhook_status: "",
    day_limit: "",
    transac_limit: "",
    beneAccNum: "",
    beneIfscCode: "",
    virtual_account_no: "",
    virtual_account_IFSC: "",
  });

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  const fund_history = useSelector((state) => state.Initiatepayout.payouts);

  const fundloads = async () => {
    const dateOnly = new Date().toISOString().slice(0, 10);

    try {
      const requestData = JSON.stringify({
        Dname: "flipopay_payouts",
        Tname: "payout",
        Cname: [
          "mid",
          "amount",
          "payout_id",
          "beneficiary_name",
          "narration",
          "open_balance",
          "close_balance",
          "response",
          "status",
          "created_at",
        ],
        Where: [
          {
            column: "mid",
            operator: "=",
            value: user_id,
          },
          {
            column: "date(created_at)",
            operator: "=",
            value: dateOnly,
          },
        ],
        Order: { id: "desc" },
        Limit: "09",
        Offset: "0",
      });

      const encrypted = encrypt(requestData);
      const data = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted },
        navigate
      );

      const decryptdata = decrypt(data);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      const jsonArray = JSON.parse(fixedString);

      dispatch(Lastpayouts(jsonArray)); // Pass the entire response
    } catch (err) {
      setError(err.message);
      AxiosError(navigate, err);
    }
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const requestData = JSON.stringify({
          Dname: "flipopay_payouts",
          Tname: "merchants m",
          Cname: [
            "m.mid",
            "merchant_id",
            "business_name",
            "payout_balance",
            "m.status",
            "webhook_status",
            "day_limit",
            "transac_limit",
            "kb.beneAccNum",
            "kb.beneIfscCode",
            "virtual_account_no",
            "virtual_account_IFSC",
          ],
          Where: [
            {
              column: "m.mid",
              operator: "=",
              value: user_id,
            },
          ],
          Jtype: "inner join",
          Jcondition: {
            "flipopay_payouts.payout_merch_bene kb": "kb.mid=m.mid",
          },
          Order: { "m.id": "desc" },
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);
        const data = await makeAuthenticatedRequest(
          "POST",
          "/fetch",
          { encrypted },
          navigate
        );

        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');
        const jsonArray = JSON.parse(fixedString);

        dispatch(Initiatepayoutmerchants(jsonArray));

        if (jsonArray.length > 0) {
          setProfileData({
            mid: jsonArray[1]["m.mid"] || "",
            payout_balance: jsonArray[1].payout_balance || "",
            status: jsonArray[1]["m.status"] || "",
            webhook_status: jsonArray[1].webhook_status || "",
            day_limit: jsonArray[1].day_limit || "",
            transac_limit: jsonArray[1].transac_limit || "",
            beneAccNum: jsonArray[1]["kb.beneAccNum"] || "",
            beneIfscCode: jsonArray[1]["kb.beneIfscCode"] || "",
            virtual_account_no: jsonArray[1].virtual_account_no || "",
            virtual_account_IFSC: jsonArray[1].virtual_account_IFSC || "",
          });
        }

        setResponseData(jsonArray);
      } catch (err) {
        setError(err.message);
        AxiosError(navigate, err);
      }
    };

    fetchProfileData();
    fundloads();
  }, [dispatch, user_id, navigate]);

  const lastpayouts =
    fund_history && fund_history.length > 0 ? fund_history : [];

  const handleHeaderViewClick = () => {
    navigate(`/Payout`);
  };

  const UpdateIp = (id) => {
    navigate(`/udpateip`, {
      state: {
        id,
      },
    });
  };

  return (
    <div className="bg-[#F4F5FA] ">
      <main className="main-content">
        <div
          className={`mx-auto p-4 md:p-6 transition-all duration-300 ${
            isSidebarCollapsed && !isMobile
              ? "ml-20"
              : !isSidebarCollapsed && !isMobile
              ? "ml-[270px]"
              : "ml-0"
          }`}
        >
          {/* Page Header */}
          <div className="mb-6 flex flex-wrap items-center justify-between ml-4">
            <div>
              <h2 className="text-xl font-semibold text-gray-800">Payouts</h2>
              {/* <p className="text-sm text-gray-600 mt-1">Manage your account payouts and transactions</p> */}
            </div>
            <nav>
              <ol className="flex items-center space-x-2 text-sm">
                <li>
                  <Link
                    className="flex items-center text-gray-500 hover:text-[#299F1F] transition-colors"
                    to="/dashboard"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      />
                    </svg>
                    Home
                  </Link>
                </li>
                <li className="text-gray-400">/</li>
                <li className="font-medium text-gray-800">Initiate Payout</li>
              </ol>
            </nav>
          </div>

          {/* <div class="flex justify-end gap-4 px-4 py-2">
            <button class="bg-[#299F1F]  text-white font-semibold py-2 px-6 rounded-lg transition duration-300 shadow">
              Bulk Payout
            </button>
            <button class="bg-[#299F1F] text-white font-semibold py-2 px-6 rounded-lg transition duration-300 shadow">
              Initiate Payout
            </button>
          </div> */}

          {/* <div class="flex justify-end gap-4 px-4 py-2">
            <button class="bg-transparent border border-[#27ae60] text-[#27ae60] hover:bg-[#299F1F] hover:text-white font-semibold py-2 px-6 rounded-lg transition shadow-sm">
              Bulk Payout
            </button>
            <button
              class="bg-transparent border border-[#27ae60] text-[#27ae60] hover:bg-[#299F1F] hover:text-white font-semibold py-2 px-6 rounded-lg transition shadow-sm"
              onClick={() => setInitiatePayout(true)}
            >
              Initiate Payout
            </button>
          </div> */}

          <div className="flex justify-end gap-4 px-4 py-2">
            <button
              class="bg-white border border-[#27ae60] text-[#27ae60] hover:bg-[#299F1F] hover:text-white font-semibold py-2 px-6 rounded-lg transition shadow-sm"
              onClick={() => UpdateIp(user_id)}
            >
              IP Whitelist
            </button>
          </div>

          {/* Modal */}
          {showInitiatePayout && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-xl shadow-lg w-full max-w-4xl p-6">
                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-semibold">Create Payout</h2>
                  <button
                    onClick={() => setInitiatePayout(false)}
                    className="text-gray-500 hover:text-black text-xl"
                  >
                    &times;
                  </button>
                </div>
                <hr></hr>

                {/* Body */}
                <div className="flex flex-col md:flex-row gap-6 mt-3">
                  {/* Left Mode Selection */}
                  <div className="w-full md:w-1/3 space-y-4">
                    {["IMPS", "RTGS", "NEFT"].map((type) => (
                      <label
                        key={type}
                        className="flex items-start space-x-2 cursor-pointer"
                      >
                        <input
                          type="radio"
                          name="transactionType"
                          value={type}
                          onChange={handleChange}
                          defaultChecked={type === "IMPS"} // <-- Set IMPS as default
                          className="mt-1"
                        />
                        <div>
                          <span className="font-medium">{type}</span>
                          <p className="text-sm text-gray-500">
                            {type === "IMPS"
                              ? "Quick and secure money transfers anytime."
                              : type === "RTGS"
                              ? "Reliable fund transfers with instant settlement."
                              : "Batch fund transfers during business hours."}
                          </p>
                        </div>
                      </label>
                    ))}
                  </div>

                  {/* Right Inputs */}
                  <form
                    onSubmit={handleSubmit}
                    className="w-full md:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-4"
                  >
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Bene Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="benename"
                        placeholder="Bene Name"
                        value={formData.benename}
                        onChange={handleChange}
                        className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                          errors.benename
                            ? "border-[#DC2626] focus:ring-[#DC2626]"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {errors.benename && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.benename}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Mobile Number <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Mobile Number"
                        className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                          errors.phone
                            ? "border-[#DC2626] focus:ring-[#DC2626]"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {errors.phone && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.phone}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email ID <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Email ID"
                        className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                          errors.email
                            ? "border-[#DC2626] focus:ring-[#DC2626]"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {errors.email && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.email}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Location <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Location"
                        className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                          errors.location
                            ? "border-[#DC2626] focus:ring-[#DC2626]"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {errors.location && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.location}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Account Number <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Account Number"
                        className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                          errors.acctno
                            ? "border-[#DC2626] focus:ring-[#DC2626]"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {errors.acctno && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.acctno}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        IFSC <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter IFSC"
                        className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                          errors.acctifsc
                            ? "border-[#DC2626] focus:ring-[#DC2626]"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {errors.acctifsc && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.acctifsc}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Bank Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Bank Name"
                        className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                          errors.bankname
                            ? "border-[#DC2626] focus:ring-[#DC2626]"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {errors.bankname && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.bankname}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Amount <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Amount"
                        className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                          errors.amount
                            ? "border-[#DC2626] focus:ring-[#DC2626]"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {errors.amount && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.amount}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Remarks <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Remarks"
                        className={`w-full p-2 text-sm border rounded-lg focus:outline-none focus:ring-2 placeholder:text-sm mt-1 ${
                          errors.remarks
                            ? "border-[#DC2626] focus:ring-[#DC2626]"
                            : "focus:ring-[#299F1F]"
                        }`}
                      />
                      {errors.remarks && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.remarks}
                        </p>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="col-span-full flex justify-end mt-4">
                      {/* <button
                        type="submit"
                        className="bg-[#27ae60] text-white px-6 py-2 rounded-md"
                      >
                        Confirm Payout
                      </button> */}
                      <button
                        type="submit"
                        className="bg-[#27ae60] text-white px-6 py-2 rounded-md"
                        disabled={loading}
                      >
                        {loading ? "Processing..." : "Confirm Payout"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          {/* Dashboard Cards Section */}
          <div className="px-4 sm:px-2 lg:px-3 mt-4">
            <div className="grid gap-8 lg:grid-cols-2">
              {/* Recent Transactions Card - Left Side */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 h-full">
                <div className="bg-gradient-to-r from-[#299F1F] to-[#4CAF50] text-white py-5 px-6 rounded-t-xl">
                  <div className="flex items-center justify-between">
                    <h2 className="text-lg font-semibold">
                      Recent Transactions
                    </h2>
                    <button
                      onClick={handleHeaderViewClick}
                      className="text-white hover:text-gray-200 text-sm font-medium"
                    >
                      View All
                    </button>
                  </div>
                </div>

                <div className="p-4 space-y-2 h-[calc(100%-68px)] overflow-y-auto">
                  {lastpayouts.slice(1).length > 0 ? (
                    lastpayouts.slice(1).map((fund, index) => {
                      let bgColor = "";
                      let textColor = "";
                      let iconColor = "";
                      let iconPath = "";

                      switch (fund.response) {
                        case "PROCESSED":
                          bgColor = "bg-green-100";
                          textColor = "text-green-700";
                          iconColor = "text-green-600";
                          iconPath = (
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            />
                          );
                          break;
                        case "FAILED":
                          bgColor = "bg-red-100";
                          textColor = "text-red-700";
                          iconColor = "text-red-600";
                          iconPath = (
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          );
                          break;
                        case "PENDING":
                          bgColor = "bg-yellow-100";
                          textColor = "text-yellow-700";
                          iconColor = "text-yellow-600";
                          iconPath = (
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          );
                          break;
                        default:
                          bgColor = "bg-gray-100";
                          textColor = "text-gray-700";
                          iconColor = "text-gray-600";
                          iconPath = (
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M12 4v16m8-8H4"
                            />
                          );
                          break;
                      }

                      return (
                        <div
                          key={index}
                          className="flex items-center justify-between bg-white shadow-sm rounded-xl p-4 border border-gray-200 gap-4"
                        >
                          {/* Icon Section */}
                          <div className={`${bgColor} p-2 rounded-lg`}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className={`h-6 w-6 ${iconColor}`}
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              {iconPath}
                            </svg>
                          </div>

                          {/* Transaction Details */}
                          <div className="flex-grow ml-3 space-y-1">
                            <p className="text-sm font-semibold text-gray-800">
                              Payment | {fund.payout_id} |{" "}
                              {fund.beneficiary_name}
                            </p>
                            <p className="text-xs text-gray-500">
                              {new Date(fund.created_at).toDateString() ===
                              new Date().toDateString()
                                ? `Today, ${new Date(
                                    fund.created_at
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}`
                                : `${new Date(
                                    fund.created_at
                                  ).toLocaleDateString()}, ${new Date(
                                    fund.created_at
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}`}{" "}
                              | {fund.narration}
                            </p>
                          </div>

                          {/* Amount Section */}
                          <div
                            className={`text-sm font-bold ${textColor} min-w-[80px] text-right`}
                          >
                            -₹{Number(fund.amount).toLocaleString("en-IN")}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="text-center py-4 text-gray-500 w-full">
                      No Recent Payout history found.
                    </div>
                  )}
                </div>
              </div>

              {/* Right Side - Stacked Cards */}
              <div className="space-y-8">
                {/* Account Details Card */}
                <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
                  <div className="bg-gradient-to-r from-[#299F1F] to-[#4CAF50] text-white py-5 px-6 rounded-t-xl">
                    <div className="flex items-center justify-between">
                      <h2 className="text-lg font-semibold">Account Details</h2>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="p-6 space-y-4">
                    <div className="flex items-start">
                      <div className="bg-green-100 p-2 rounded-full mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-green-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">
                          Loading Account No
                        </p>
                        <p className="font-medium text-gray-800">
                          {profileData.beneAccNum}
                        </p>
                      </div>
                    </div>

                    <div className="border-t border-gray-100"></div>

                    <div className="flex items-start">
                      <div className="bg-blue-100 p-2 rounded-full mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Account IFSC</p>
                        <p className="font-medium text-gray-800">
                          {profileData.beneIfscCode}
                        </p>
                      </div>
                    </div>

                    <div className="border-t border-gray-100"></div>

                    <div className="flex items-start">
                      <div className="bg-purple-100 p-2 rounded-full mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">
                          Virtual Account No
                        </p>
                        <p className="font-medium text-gray-800">
                          {profileData.virtual_account_no}
                        </p>
                      </div>
                    </div>

                    <div className="border-t border-gray-100"></div>

                    <div className="flex items-start">
                      <div className="bg-amber-100 p-2 rounded-full mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-amber-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">
                          Virtual Account IFSC
                        </p>
                        <p className="font-medium text-gray-800">
                          {profileData.virtual_account_IFSC}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* API Status Card */}
                <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
                  <div className="bg-gradient-to-r from-[#299F1F] to-[#4CAF50] text-white py-5 px-6 rounded-t-xl">
                    <div className="flex items-center justify-between">
                      <h2 className="text-lg font-semibold">API Status</h2>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13 10V3L4 14h7v7l9-11h-7z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="p-6 space-y-4">
                    <div className="flex items-start">
                      <div className="bg-green-100 p-2 rounded-full mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-green-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">API Status</p>
                        <span
                          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                            profileData.status === "1"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {profileData.status === "1" ? "Active" : "Inactive"}
                        </span>
                      </div>
                    </div>

                    <div className="border-t border-gray-100"></div>

                    <div className="flex items-start">
                      <div className="bg-blue-100 p-2 rounded-full mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Callback Status</p>
                        <span
                          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                            profileData.webhook_status === "1"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {profileData.webhook_status === "1"
                            ? "Active"
                            : "Inactive"}
                        </span>
                      </div>
                    </div>

                    <div className="border-t border-gray-100"></div>

                    <div className="flex items-start">
                      <div className="bg-purple-100 p-2 rounded-full mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">
                          Maximum Transaction Value
                        </p>
                        <p className="font-medium text-gray-800">
                          ₹ {profileData.transac_limit}
                        </p>
                      </div>
                    </div>

                    <div className="border-t border-gray-100"></div>

                    <div className="flex items-start">
                      <div className="bg-amber-100 p-2 rounded-full mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-amber-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">
                          Minimum Transaction Value
                        </p>
                        <p className="font-medium text-gray-800">₹ 100.00</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Initiatepayout;
